import CustomersPage from "../../../features/admin/customers/customers-page";

export default function Customers() {
  return <CustomersPage />;
}
